const DOCS_ASSISTANT_BASE_URL = 'https://github.com/RainerTekOrg/pingr-notify#documentation';

export function getDocsAssistantUrl(query?: string): string {
  const trimmedQuery = query?.trim();

  if (!trimmedQuery) {
    return `${DOCS_ASSISTANT_BASE_URL}?assistant`;
  }

  return `${DOCS_ASSISTANT_BASE_URL}?assistant=${encodeURIComponent(trimmedQuery)}`;
}

export function openDocsAssistant(query?: string): void {
  window.open(getDocsAssistantUrl(query), '_blank', 'noopener,noreferrer');
}
